// @ts-nocheck
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import {
    CartLineModel,
    InvoiceLineModel,
    OrderLineModel,
    ProductDto,
    ProductModel,
    WishListLineModel,
} from "@insite/client-framework/Types/ApiModels";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

export const logDebug = (type: string) => {
    ga.util.logDebug(`Mapping event "Items" as "${type}" ...`);
};

const mapItems = <T extends TrackEventParameters["items"]>(items: T, options?: Toolkit.GoogleAnalytics.Options) => {
    if (!ga.enabled) {
        return undefined;
    }

    const _items = ga.util.itemsToArray(items);

    if (!_items) {
        return undefined;
    }

    const item = _items[0] as any;

    if (item) {
        const productContext = item as ProductContextModel;
        if (productContext.product && productContext.productInfo) {
            logDebug("ProductContextModel");
            return ga.map.manyItems(_items as ProductContextModel[], ga.map.productContextModel, options);
        }

        const orderLine = item as OrderLineModel;
        if (typeof orderLine.isActiveProduct === "boolean") {
            logDebug("OrderLineModel");
            return ga.map.manyItems(_items as OrderLineModel[], ga.map.orderLineModel, options);
        }

        const productDto = item as ProductDto;
        if (typeof productDto.allowAnyGiftCardAmount === "boolean") {
            logDebug("ProductDto");
            return ga.map.manyItems(_items as ProductDto[], ga.map.productDto, options);
        }

        // Store Custom Code - inverse ProductModel with CartLineModel
        const cartLine = item as CartLineModel;
        if (typeof cartLine.baseUnitOfMeasure === "string") {
            logDebug("CartLineModel");
            return ga.map.manyItems(_items as CartLineModel[], ga.map.cartLineModel, options);
        }

        const product = item as ProductModel;
        if (typeof product.cantBuy === "boolean") {
            logDebug("ProductModel");
            return ga.map.manyItems(_items as ProductModel[], ga.map.productModel, options);
        }

        const wishListLine = item as WishListLineModel;
        if (typeof wishListLine.isSharedLine === "boolean") {
            logDebug("WishListLineModel");
            return ga.map.manyItems(_items as WishListLineModel[], ga.map.wishListLineModel, options);
        }

        const invoiceLine = item as InvoiceLineModel;
        if (typeof invoiceLine.qtyInvoiced === "number") {
            logDebug("InvoiceLineModel");
            return ga.map.manyItems(_items as InvoiceLineModel[], ga.map.invoiceLineModel, options);
        }
    }

    return ga.map.manyItems(_items as Toolkit.GoogleAnalytics.AnyItem[], undefined, options);
};

export default mapItems;
